import { Navigate, useLocation, useSearchParams } from "react-router-dom"

import { useAuth } from "providers/auth"

const RequireNoAuth: React.FC = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()
  const [params] = useSearchParams()

  if (!user) return <>{children}</>

  return (
    <Navigate
      to={
        (location.state as any)?.redirectTo || params.get("redirectTo") || "/"
      }
    />
  )
}

export default RequireNoAuth
